(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll("[data-gemist-section]");

    sections.forEach((section) => {
      if (section.dataset.gemistInitialized === "true") return;

      section.dataset.gemistInitialized = "true";

      const baseURL = "https://happyjewelers.gemist.co/";
      const cover = section.querySelector("[data-designer-cover]");
      const wrapper = section.querySelector("[data-designer-wrapper]");
      const iframe = section.querySelector("[data-designer-iframe]");
      const openButton = section.querySelector("[data-open-designer]");
      const stepsTrack = section.querySelector("[data-steps-track]");
      const stepCards = Array.from(
        section.querySelectorAll("[data-step]")
      );
      const stepDots = Array.from(
        section.querySelectorAll("[data-step-dot]")
      );

      let designerLoaded = false;

      const buildDesignerURL = () => {
        return `${baseURL}designer/engagement${window.location.search}`;
      };

      const updateDesignerHeight = () => {
        if (!wrapper || !iframe || wrapper.hidden) return;

        const header = document.querySelector("header");

        const headerHeight = header
          ? Math.ceil(header.getBoundingClientRect().height)
          : 0;

        const viewportHeight = window.visualViewport
          ? window.visualViewport.height
          : window.innerHeight;

        const designerHeight = Math.max(
          500,
          Math.floor(viewportHeight - headerHeight - 20)
        );

        wrapper.style.height = `${designerHeight}px`;
        iframe.style.height = `${designerHeight}px`;
      };

      const openDesigner = () => {
        if (!iframe || !cover || !wrapper) return;

        if (!designerLoaded) {
          iframe.src = buildDesignerURL();
          designerLoaded = true;
        }

        cover.hidden = true;
        wrapper.hidden = false;

        updateDesignerHeight();

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      };

      if (openButton) {
        openButton.addEventListener("click", openDesigner);
      }

      const setActiveDot = (index) => {
        stepDots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;

          dot.classList.toggle("is-active", isActive);

          dot.setAttribute(
            "aria-current",
            isActive ? "true" : "false"
          );
        });
      };

      stepDots.forEach((dot) => {
        dot.addEventListener("click", () => {
          const index = Number(dot.dataset.stepDot);
          const targetCard = stepCards[index];

          if (!targetCard || !stepsTrack) return;

          stepsTrack.scrollTo({
            left: targetCard.offsetLeft - stepsTrack.offsetLeft,
            behavior: "smooth"
          });

          setActiveDot(index);
        });
      });

      if (stepsTrack && stepCards.length > 1) {
        let scrollTimer;

        stepsTrack.addEventListener(
          "scroll",
          () => {
            window.clearTimeout(scrollTimer);

            scrollTimer = window.setTimeout(() => {
              const trackLeft =
                stepsTrack.getBoundingClientRect().left;

              let closestIndex = 0;
              let closestDistance = Infinity;

              stepCards.forEach((card, index) => {
                const cardLeft =
                  card.getBoundingClientRect().left;

                const distance = Math.abs(
                  cardLeft - trackLeft
                );

                if (distance < closestDistance) {
                  closestDistance = distance;
                  closestIndex = index;
                }
              });

              setActiveDot(closestIndex);
            }, 80);
          },
          {
            passive: true
          }
        );
      }

      window.addEventListener(
        "resize",
        updateDesignerHeight
      );

      if (window.visualViewport) {
        window.visualViewport.addEventListener(
          "resize",
          updateDesignerHeight
        );
      }

      const header = document.querySelector("header");

      if (header && "ResizeObserver" in window) {
        const headerObserver = new ResizeObserver(
          updateDesignerHeight
        );

        headerObserver.observe(header);
      }

      window.addEventListener(
        "message",
        function (event) {
          if (!event.data) return;

          let message;

          try {
            message =
              typeof event.data === "string"
                ? JSON.parse(event.data)
                : event.data;
          } catch (error) {
            return;
          }

          if (!message || !message.type) return;

          switch (message.type) {
            case "buy": {
              const id =
                message.product.Shopify.productVariant
                  .split("/")
                  .slice(-1)[0];

              const size = message.size;
              const items = [];

              const product = {
                id,
                quantity: 1,
                properties: {
                  Size: size,
                  _disable_click: true
                }
              };

              if (message.engravingTextRing) {
                const engraving = {
                  id: "47241281175778",
                  quantity: 1,
                  properties: {
                    Text:
                      message.engravingTextRing.toUpperCase(),
                    _variant_id: id,
                    _disable_click: true
                  }
                };

                product.properties.Engraving =
                  message.engravingTextRing.toUpperCase();

                items.push(engraving);
              }

              if (message.matchingBand) {
                const matchingBand = {
                  id:
                    message.matchingBand.Shopify.productVariant
                      .split("/")
                      .slice(-1)[0],
                  quantity: 1,
                  properties: {
                    _disable_click: true
                  }
                };

                if (message.engravingRingBand) {
                  const engravingRingBand = {
                    id: "47241277931746",
                    quantity: 1,
                    properties: {
                      Text:
                        message.engravingRingBand.toUpperCase(),
                      _variant_id: matchingBand.id,
                      _disable_click: true
                    }
                  };

                  matchingBand.properties.Engraving =
                    message.engravingRingBand.toUpperCase();

                  items.push(engravingRingBand);
                }

                items.push(matchingBand);
              }

              items.push(product);

              if (
                message.diamond &&
                message.diamond.variantId !== undefined
              ) {
                items.push({
                  id: message.diamond.variantId
                    .split("/")
                    .slice(-1)[0],
                  quantity: 1
                });
              }

              const cart =
                window.cart ||
                document.querySelector(
                  "cart-notification"
                ) ||
                document.querySelector("cart-drawer");

              fetch(
                `${window.Shopify.routes.root}cart/add.js`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    items
                  })
                }
              )
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(
                      "Unable to add items to cart."
                    );
                  }

                  if (
                    cart &&
                    typeof cart.getCart === "function"
                  ) {
                    cart.getCart();
                  }

                  document.dispatchEvent(
                    new Event("cart:refresh")
                  );

                  return fetch("/cart.js");
                })
                .then((response) => response.json())
                .then((cartData) => {
                  const count = cartData.item_count;

                  document
                    .querySelectorAll(
                      "cart-count, .count, [data-cart-count], .cart-count"
                    )
                    .forEach((element) => {
                      element.textContent = count;

                      element.setAttribute(
                        "aria-label",
                        `${count} items`
                      );

                      if (count > 0) {
                        element.removeAttribute("hidden");
                        element.style.display = "";
                      } else {
                        element.setAttribute("hidden", "");
                      }
                    });

                  const cartButton =
                    document.querySelector(
                      ".cart-drawer-button"
                    ) ||
                    document.querySelector(
                      '[aria-controls="CartDrawer"]'
                    );

                  if (cartButton) {
                    cartButton.click();
                  }
                })
                .catch((error) => {
                  console.error(
                    "Gemist cart error:",
                    error
                  );
                });

              break;
            }

            case "favorite": {
              const id = message.product?.id;

              if (!id) break;

              fetch(
                `${baseURL}api/products/${id}/shmetadata`
              )
                .then((response) => response.json())
                .then((data) => {
                  const elementToSave =
                    document.createElement("div");

                  elementToSave.dataset.id =
                    data.productId
                      .split("/")
                      .slice(-1)[0];

                  elementToSave.dataset.handle =
                    data.handle;

                  if (
                    typeof window.saveWishlist ===
                      "function" &&
                    typeof window.jQuery !== "undefined"
                  ) {
                    window.saveWishlist(
                      window.jQuery(elementToSave)
                    );
                  }
                })
                .catch((error) => {
                  console.error(
                    "Gemist wishlist error:",
                    error
                  );
                });

              break;
            }

            case "updateParams": {
              const currentURL = new URL(
                window.location.href
              );

              const paramNames =
                message.paramNames || [];

              paramNames.forEach((paramName) => {
                const paramValue =
                  message[paramName];

                if (paramValue !== undefined) {
                  currentURL.searchParams.set(
                    paramName,
                    paramValue
                  );
                }
              });

              window.history.replaceState(
                {},
                "",
                currentURL.toString()
              );

              break;
            }

            case "download":
              if (message.downloadHref) {
                window.open(
                  message.downloadHref,
                  "_blank"
                );
              }
              break;

            case "copywindowlocation":
              navigator.clipboard
                .writeText(window.location.href)
                .catch((error) => {
                  console.error(
                    "Unable to copy designer URL:",
                    error
                  );
                });
              break;

            case "sendemail": {
              let {
                emailContent = "",
                subject = "",
                recipient = ""
              } = message;

              emailContent = emailContent.replace(
                "{{currentPageLink}}",
                window.location.href
              );

              const mailtoLink =
                `mailto:${recipient}` +
                `?subject=${encodeURIComponent(subject)}` +
                `&body=${encodeURIComponent(emailContent)}`;

              window.open(mailtoLink, "_blank");

              break;
            }

            case "requestfullscreen":
              if (iframe?.requestFullscreen) {
                iframe.requestFullscreen();
              }
              break;

            default:
              break;
          }
        },
        false
      );
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
